import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import state from './state'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
	storage: window.localStorage
})

export default new Vuex.Store({
	state,
	mutations: {
	  setAppConfig(state, newData){
		state.appConfig = newData;
	  }
	},
	actions: {

	},
	modules: {},
	plugins: [vuexLocal.plugin]
})



// WEBPACK FOOTER //
// ./src/store/index.js